import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.role !== 'drfahm_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function ReviewerRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Reviewers only. Admins are sent to their own panel; anyone else to dashboard.
  if (user.role !== 'question_reviewer') {
    return <Navigate to={user.role === 'drfahm_admin' ? '/admin' : '/dashboard'} replace />;
  }

  return children;
}

function SchoolLeaderRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // School leaders and admins (admins view any org via /school/:orgId).
  // This gate is cosmetic; GET /api/schools/:orgId/dashboard enforces
  // ownership server-side and returns 403 org_mismatch regardless.
  if (user.role !== 'school_leader' && user.role !== 'drfahm_admin') {
    return <Navigate to={user.role === 'question_reviewer' ? '/review' : '/dashboard'} replace />;
  }

  return children;
}

export { ProtectedRoute, AdminRoute, ReviewerRoute, SchoolLeaderRoute };